module.exports = __webpack_public_path__ + "static/media/JH_web_9.05e73c01.jpg";